export default __webpack_public_path__ + "locales/vi/SocialAuthWelcomeDialog.json?hash=c4a8859b811eb88e82180b65f5f2012f";